import { Injectable, Inject, ChangeDetectorRef, Injector } from '@angular/core';
import { AgoraService } from './agora.service';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import { BaseService } from 'src/modules/base/shared/services/base.service';

@Injectable({
    providedIn: 'root'
})
export class TelemedicineService {
    public message = new Subject<boolean>();
    public secondMessage = new Subject<boolean>();

    constructor(@Inject(DOCUMENT) document: Document,
        public baseServices: BaseService,
        public injector: Injector
    ) {
        this.baseServices.setTeleService(this);
    }
    public allServices: any = {
        'agora': AgoraService
    }
    public defaultService = 'agora';
    public currentInstance: any;
    public currentCall: any = false;

    init(callback) {
        this.currentInstance = new this.allServices[this.defaultService](this.injector, this.baseServices);
        this.currentInstance.lazyLoadScript(document).subscribe(_ => {
            callback();
        });
    }

    changeToMiniPlayer() {
        this.currentCall.fullScreen = false;
        this.currentCall.minimized = false;
    }
    changeToPopup() {
        this.currentCall.fullScreen = true;
        this.currentCall.minimized = false;
    }
    changeToMinimized() {
        this.currentCall.fullScreen = false;
        this.currentCall.minimized = true;
    }
    closeCall(callback?: any) {
        this.currentCall.callbackApiInit = callback;
        this.currentCall = false;
    }

    initCallData(data, hasName, channel_id: any, order_id?: any, action?: any, hasPatientdata?: any, callback?: any) {
        console.log("hasvalue is :: ", hasPatientdata);
        console.log("hasName is :: ", hasName);
        this.currentCall = {};
        this.currentCall.fullScreen = true;
        this.currentCall.data = data;
        this.currentCall.name = hasName;
        this.currentCall.channelId = channel_id;
        this.currentCall.orderId = order_id;
        this.currentCall.priorityCode = hasPatientdata?.priorityCode ?? "";
        this.currentCall.callbackApiInit = callback;
        this.setMessage(true);
        if (hasPatientdata)
            this.currentCall.emrKey = hasPatientdata
        if (action)
            this.currentCall.action = action;
    }

    setMessage(value: boolean) {
        this.message.next(value);
    }

    joinChannel(data: any) {
        this.initCallData(data.payload, data.g_created_by_name, data.payload.channelId, data.payload)
    }

    hasMessage(value: boolean) {
        this.secondMessage.next(value)
    }

}